import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, AsyncValidator } from '@angular/forms';
import { ClientTypeDto } from '../../../../../interfaces/Dtos/client-type.dto';
import { ClientDto } from '../../../../../interfaces/Dtos/client.dto';
import { ClientService } from '../../services/client.service';

@Component({
  selector: 'neoris-client-new-update',
  templateUrl: './client-new-update.component.html',
  styleUrls: ['./client-new-update.component.css']
})
export class ClientNewUpdateComponent implements OnInit, OnChanges {

  formClient: UntypedFormGroup = new UntypedFormGroup({})

  @Input() clientList: ClientDto[] = []
  @Input() clientTypesList: ClientTypeDto[] = []
  @Input() condition: string = ''
  @Input() clientEdit: ClientDto = null

  @Output() closeEvent = new EventEmitter<void>();
  @Output() refreshEvent = new EventEmitter<void>();

  @ViewChild('_code') _code: ElementRef
  @ViewChild('_name') _name: ElementRef
  @ViewChild('_parentId') _parentId: ElementRef
  @ViewChild('_typeId') _typeId: ElementRef
  @ViewChild('_govNumber') _govNumber: ElementRef

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(evt: KeyboardEvent) {
    this.Cancel()
  }

  constructor(
    private clientService: ClientService,
    private builder: UntypedFormBuilder) {
  }

  get name() {
    return this.formClient.get('name')
  }

  get code() {
    return this.formClient.get('code')
  }

  get typeId() {
    return this.formClient.get('typeId')
  }

 
  ngOnInit(): void {
    this.configForm()
  }

  configForm() {
    this.formClient = this.builder.group({
      code: ['',
        {
          validators: [Validators.required, Validators.maxLength(25)],
          AsyncValidator: [this.clientService.validate.bind(this.clientService)],
          updateOn: 'blur'
        }],
      name: ['', [Validators.required]],
      parentId: ['', []],
      typeId: ['', [Validators.required]],
      govNumber: ['', []]
    })
  }

  cleanValidators(controls: string[]): void {
    controls.forEach(element => {
      this.formClient.controls[element].setErrors(null)
      this.formClient.controls[element].clearValidators();
      this.formClient.controls[element].updateValueAndValidity()
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.clientEdit?.currentValue === null && changes.clientEdit?.firstChange === false) {
      this.cleanValidators(['code', 'name', 'parentId'])
    }
    if ((changes.clientEdit?.currentValue !== undefined && changes.clientEdit?.currentValue !== null)
      && (this.clientEdit !== undefined && this.clientEdit !== null)) {
      this.setDropDowns()
    } else {
      this.formClient.controls['typeId']?.setValue('')
      this.formClient.controls['parentId']?.setValue('')
    }
  }

  setDropDowns() {
    this.setCleanSelected()
    if (this.clientList.filter(c => c.id === this.clientEdit.parentId).length > 0)
      this.clientList.filter(c => c.id === this.clientEdit.parentId)[0].selected = true
    else
      this.formClient.controls['parentId'].setValue('')
    if (this.clientTypesList.filter(c => c.id === this.clientEdit.clientTypeId).length > 0)
      this.clientTypesList.filter(c => c.id === this.clientEdit.clientTypeId)[0].selected = true
    else
      this.formClient.controls['typeId'].setValue('')
  }

  setCleanSelected(): void {
    if ((this.clientList !== undefined && this.clientList !== null) && this.clientList.length > 0)
      for (let index = 0; index < this.clientList.length; index++) {
        this.clientList[index].selected = false
      }
    if ((this.clientTypesList !== undefined && this.clientTypesList !== null) && this.clientTypesList.length > 0)
      for (let index = 0; index < this.clientTypesList.length; index++) {
        this.clientTypesList[index].selected = false
      }
  }

  onSubmit(values: any) {
    if (this.condition === 'New Client') {
      
      const client: ClientDto = {
        id: 0,
        code: values.code,
        name: values.name,
        parentId: values.parentId || 0,
        clientTypeId: values.typeId || 0,
        govNumber: values.govNumber || 0,
        tenantUuid: '',
        parentIdName: '',
        clientTypeName: '',
        selected: false
      }
      this.addClient(client)
      
    } else {
      console.log(values)
      console.log(this.formClient.value)
      const code: string = this._code.nativeElement.value
      const name: string = this._name.nativeElement.value
      const parentId: string = this._parentId.nativeElement.value
      const typeId: string = this._typeId.nativeElement.value
      const govNumber: string = this._govNumber.nativeElement.value
      const client: ClientDto = {
        id: this.clientEdit.id,
        code: code,
        name: name,
        parentId: parseInt(parentId) || 0,
        clientTypeId: parseInt(typeId) || 0,
        govNumber: parseInt(govNumber) || 0,
        tenantUuid: '',
        parentIdName: '',
        clientTypeName: '',
        selected: false
      }
      this.editClient(client)
    }
  }

  async editClient(client: ClientDto) {
    console.log('editClient', client)
    const response = await this.clientService.EditClient(client.id, client).toPromise()
    console.log(response)
    this.Cancel()
    this.refreshEvent.emit()
  }

  async addClient(client: ClientDto) {
    console.log('addClient', client)
    const response = await this.clientService.AddClient(client).toPromise()
    console.log(response)
    this.Cancel()
    this.refreshEvent.emit()
  }

  Cancel() {
    this.closeEvent.emit()
  }

  validate(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode
    if (charCode >= 65 && charCode <= 90) return true
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }

  validatePaste(event: ClipboardEvent): boolean {
    let clipboardData = event.clipboardData
    let pastedText = clipboardData.getData('text')
    return this.soloNumeros(pastedText)
  }

  soloNumeros(campo: any): boolean {
    let validos = '0123456789'
    let letra: string
    let bien = true
    for (let i = 0; i < campo.length; i++) {
      letra = campo.charAt(i).toLowerCase()
      if (validos.indexOf(letra) == -1) bien = false
    }
    return bien
  }

}
